import React, { useContext } from "react"
import defaultPrep from "../data/manual/prep-counters.json"

const PrepCounterCtx = React.createContext(null)

export const PrepCounterProvider = ({ children }) => {
  const [map, setMap] = React.useState(defaultPrep)
  return (
    <PrepCounterCtx.Provider
      value={{
        map,
        setMap,
      }}
    >
      {children}
    </PrepCounterCtx.Provider>
  )
}

export const usePrepCounterCtx = () => {
  const data = useContext(PrepCounterCtx)
  if (!data) throw new Error("called context hook outside provider")
  return data
}
